import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'

import { IFilterState } from '../data-filters/models/ifilter-state'
import { UnmodifiableFilterStateWrapper } from '../data-filters/models/unmodifiable-filter-state-wrapper'

@Injectable({
  providedIn: 'root',
})
export class ObservableService {
  private viewProductSource: BehaviorSubject<string> = new BehaviorSubject('')
  viewProductClickValue = this.viewProductSource.asObservable()

  private viewFilterBySource: BehaviorSubject<string> = new BehaviorSubject('')
  viewFilterByClickValue = this.viewFilterBySource.asObservable()

  private filterBySelectedItemSource = new BehaviorSubject({})
  filterBySelectedItemValue = this.filterBySelectedItemSource.asObservable()

  private rowRecordSource = new BehaviorSubject(0)
  rowRecordValue = this.rowRecordSource.asObservable()

  private viewTypeSource = new BehaviorSubject('monthEndReturnNAV')
  viewTypeValue = this.viewTypeSource.asObservable()

  private userSelectionValue = new BehaviorSubject({})
  userSelectedValue = this.userSelectionValue.asObservable()

  private sharedClassValue = new BehaviorSubject(false)
  sharedClassSelectedValue = this.sharedClassValue.asObservable()

  private benchmarkValue = new BehaviorSubject(false)
  benchmarkSelectedValue = this.benchmarkValue.asObservable()

  private consolidateFilters = new BehaviorSubject(
    <IFilterState>new UnmodifiableFilterStateWrapper(),
  )
  consolidateFiltersObservable = this.consolidateFilters.asObservable()

  private searchValue = new Subject<string>()
  searchSelectedValue = this.searchValue.asObservable()

  private isFundLiteratureContentValueFetched = new BehaviorSubject(false)
  isFundLiteratureContentValueAvailable =
    this.isFundLiteratureContentValueFetched.asObservable()

  private toggleOnSource = new BehaviorSubject<boolean>(false)
  toggleOnValue = this.toggleOnSource.asObservable()

  changeToggleOnValue(value: boolean) {
    this.toggleOnSource.next(value)
  }

  private coverSpinnerValue = new Subject<boolean>()
  coverSpinnerSelected = this.coverSpinnerValue.asObservable()

  coverSpinnerTrigger(value: boolean) {
    this.coverSpinnerValue.next(value)
  }

  viewProductClick(value: string) {
    this.viewProductSource.next(value)
  }

  viewFilterByClick(value: string) {
    this.viewFilterBySource.next(value)
  }

  filterBySelectedItem(assetClassItem: any) {
    this.filterBySelectedItemSource.next(assetClassItem)
  }
  changeRowRecordValue(value: number) {
    this.rowRecordSource.next(value)
  }
  changeViewTypeValue(value: string) {
    this.viewTypeSource.next(value)
  }
  changeSharedClassSelection(value: boolean) {
    this.sharedClassValue.next(value)
  }
  changeBenchmarkSelection(value: boolean) {
    this.benchmarkValue.next(value)
  }
  changeConsolidateFiltersObservable(filterStateObj: IFilterState) {
    this.consolidateFilters.next(filterStateObj)
  }
  changeSearchSelection(value: string) {
    this.searchValue.next(value)
  }
  changeIsFundLiteratureContentValueFetch(value: boolean) {
    this.isFundLiteratureContentValueFetched.next(value)
  }
}
